import { Component, OnInit } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../services";

type UserFields = "email" | "password";
type FormErrors = { [u in UserFields]: string };

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {

    public newUser = false;
    public user: firebase.User;
    public loginForm: FormGroup;
    public formErrors: FormErrors = {
        email: "",
        password: "",
    };
    public errorMessage: any;

    private returnUrl: string;

    constructor(
        private readonly route: ActivatedRoute,
        public readonly authService: AuthService,
        private readonly afauth: AngularFireAuth,
        private readonly fb: FormBuilder,
        private readonly router: Router,
    ) {
        this.loginForm = fb.group({
            email: ["david@envisability.com", [Validators.required, Validators.email]],
            password: ["O7oMCUXM9nGON9emZ89OTIvLh", Validators.required],
        });
    }

    ngOnInit() {
        if (this.authService.isLoggedIn) {
            this.authService.SignOut()
                .then(() => {
                    console.log("Signout");
                })
                .catch(() => { });
        }

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
        console.log(`this.returnUrl = ${this.returnUrl}`);
    }

    // Login With Google
    loginGoogle() {
        this.authService.GoogleAuth()
            .then(() => this.continueLogin());
    }

    // Login With Twitter
    loginTwitter(): void {
        this.authService.signInTwitter()
            .then(() => this.continueLogin());
    }

    // Login With Facebook
    loginFacebook() {
        this.authService.signInFacebok()
            .then(() => this.continueLogin());
    }

    // Simple Login
    login() {
        this.authService.SignIn(this.loginForm.value["email"], this.loginForm.value["password"])
            .then(() => this.continueLogin());
    }

    private continueLogin() {
        this.router.navigateByUrl(this.returnUrl);
    }

}
